export class HeatingUpdateLayout {
	public fields = [
		{ fieldName: 'heatingUpdateIndicator', label: 'Indicator' },
		{ fieldName: 'heatingUpdateType', label: 'Type' },
		{ fieldName: 'heatingUpdateTimeframe', label: 'Timeframe' },
		{ fieldName: 'heatingUpdateDescription', label: 'Description' }
	];
}
